import React from 'react';
import ExternalFactsheetLink from '../ExternalFactsheetLink';
import { tripFactsheetUrl } from '@koob/utils';

export default function TripDayHotelHeader({
  hasFloatingControls,
  hotelImage,
  hotel,
  tripFilters,
  isIncludedHotel,
  suggestedHotelIds,
  onShowSuggestedHotels,
  t,
}: {
  hasFloatingControls: boolean;
  hotelImage: string;
  hotel: any;
  tripFilters: any;
  isIncludedHotel: any;
  suggestedHotelIds: any[];
  onShowSuggestedHotels: () => void;
  t: (key: string, options?: Record<string, any>) => string;
}) {
  return (
    <div
      className={`flex space-x-2 ${hasFloatingControls ? 'pr-7' : 'pr-1.5'}`}
    >
      <div>
        <div className="relative h-10 w-10 rounded overflow-hidden">
          <img
            src={hotelImage}
            onError={(ev: any) =>
              (ev.target.src = '/img/hotel-image-placeholder.png')
            }
            className="absolute inset-0 h-full w-full object-cover rounded"
          />
        </div>
      </div>

      <div className="text-xs font-medium text-gray-900">
        <ExternalFactsheetLink
          name={hotel?.name ?? hotel?.displayName ?? ''}
          href={tripFactsheetUrl(`/hotels/${hotel?.id}`, {
            locale: tripFilters?.locale,
            tripId: tripFilters?.tripId,
          })}
          label={t('compose.openHotelFactsheet')}
        />

        {isIncludedHotel && (
          <div className="text-gray-500">
            <i className="fas fa-exchange mr-1" />
            {t('compose.orOneOfxHotels', {
              count: suggestedHotelIds.length,
            })}
          </div>
        )}

        <div className="text-xs">
          <div className="text-gray-500">{hotel?.address}</div>

          {isIncludedHotel && (
            <button
              onClick={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
                onShowSuggestedHotels();
              }}
              className="mt-1 text-k-orange border-none"
            >
              {t('compose.seeAlternativeHotels')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
